import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AvailablePopups } from 'store/app/types';
import Accordion from '../../Common/Accordion/Accordion';
import Popup from '../../Common/Popup/Popup';
import showPopupOperation from '../../../store/app/operation/showPopupOperation';
import styles from './StudioProductDetails.module.scss';

export interface StudioProductDetailsProps {
  productDetailsPopup: string;
  productDescription: string;
}

const StudioProductDetails: FC<StudioProductDetailsProps> = ({ productDescription, productDetailsPopup }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const getProductDetails = () => productDescription || '';

  // eslint-disable-next-line no-unneeded-ternary
  const getProductDetailsPopup = productDetailsPopup ? productDetailsPopup : false;
  const showPopupDetails = () => dispatch(showPopupOperation(AvailablePopups.productDetailsPopup));

  return (
    <div className={styles.productDetailsContent}>
      {getProductDetails() && (
        <Accordion title={t('txt_product_page_product_description')} titleClassName={styles.title}>
          <div className={styles.content}>
            <span dangerouslySetInnerHTML={{ __html: getProductDetails() || '' }} />

            {getProductDetailsPopup && (
              <div onClick={showPopupDetails} className={styles.showMore}>
                {t('txt_product_more_details_popup_cta')}
              </div>
            )}
          </div>
        </Accordion>
      )}

      {getProductDetailsPopup && (
        <Popup
          popupId={AvailablePopups.productDetailsPopup}
          title={t('txt_product_page_product_description')}
          applyButtonTitle={t('txt_close')}
        >
          <span dangerouslySetInnerHTML={{ __html: getProductDetailsPopup }} />
        </Popup>
      )}
    </div>
  );
};

export default StudioProductDetails;
